import WindowModal from './WindowModal';
import ContentProviderHtmlElement from '../lib/modals/content_providers/ContentProviderHtmlElement';

class DesktopSearchbarLocationModal extends WindowModal {

  constructor(searchbar) {
    super(new ContentProviderHtmlElement(document.querySelector('.js-desktopDMN-DOM')));
    this.searchbar = searchbar;
    this.contentHandlers = {};
    this.contentElements = {};
  }

  initContent() {
    super.initContent();
    this.initTabbedMenu();
    this.initLinks();
  }

  uninitContent() {
    super.uninitContent();
    this.uninitTabbedMenu();
    this.contentHandlers = {};
    this.contentElements = {};
  }

  initLinks() {
    //TODO: refactor when searchbar is refactored
    [...this.elements.modal_content.querySelectorAll('.modal-content a')].map(link => {
      link.setAttribute('href', 'javascript:void(0);');
      link.addEventListener('click', event => {
        event.preventDefault();
        this.searchbar.field.camp.querySelector(
          '[value="' + link.getAttribute('data-be') + '"]',
        ).selected = true;
        if ('createEvent' in document) {
          const evt = document.createEvent('HTMLEvents');
          evt.initEvent('change', false, true);
          this.searchbar.field.camp.dispatchEvent(evt);
        } else {
          this.searchbar.field.camp.fireEvent('onchange');
        }
        this.close();
      });
    });
  }

  initTabbedMenu() {
    this.contentElements['menu_tabs'] = this.elements.modal_content.querySelectorAll('.js-drop-display');
    this.contentElements['menu_tab_containers'] = this.elements.modal_content.querySelectorAll('.js-dropdown-display-item');
    this.contentHandlers['menu_tabs'] = new Map();
    this.contentElements['menu_tabs'].forEach(tabElement => {
      this.contentHandlers['menu_tabs'].set(tabElement, (eventObj) => {
        eventObj.preventDefault();
        const targetMenuTabContainer = this.elements.modal_content.querySelector(`.${eventObj.currentTarget.dataset.target}`);
        this.contentElements['menu_tabs'].forEach(element => element.classList.remove('active'));
        this.contentElements['menu_tab_containers'].forEach(element => element.classList.remove('active'));
        eventObj.currentTarget.classList.add('active');
        targetMenuTabContainer.classList.add('active');
      });
      tabElement.addEventListener('click', this.contentHandlers['menu_tabs'].get(tabElement));
    });
  }

  uninitTabbedMenu() {
    this.contentHandlers['menu_tabs'].forEach((handler, element) => {
      element.removeEventListener('click', handler);
    });
  }
}

export default DesktopSearchbarLocationModal;




// WEBPACK FOOTER //
// ./src/js/modals/DesktopSearchBarLocationModal.js